import { Routes } from '@angular/router';
import { CognitoGuardService } from './services/cognito/cognito-guard.service';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './services/auth/auth-guard.service';
import { ExternalLayoutComponent } from './layouts/external/external-layout/external-layout.component';
import { GlobalSupplierGuardService } from './services/guards/global-supplier-guard.service';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: AuthLayoutComponent,
    //canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
      },
    ],
  },
  {
    path: 'external',
    component: ExternalLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: 'pages',
    component: AdminLayoutComponent,
    canActivate: [CognitoGuardService],
    canActivateChild: [GlobalSupplierGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: 'testing',
    component: AdminLayoutComponent,
    canActivate: [CognitoGuardService],
    pathMatch: 'full',
    children: [
      {
        path: '',
        loadChildren: () => import('./testing/testing.module').then((m) => m.TestingModule),
      },
    ],
  },
];

